<template>
  <div></div>
</template>
<script>
export default {
  name: "MAP",
};
</script>
